module.exports = __webpack_public_path__ + "static/media/trofeo1.af3994cf.png";